import AppUtil from './AppUtil';

/**
 * 로깅 유틸리티
 * 개발 환경에서만 로그를 출력하고, 프로덕션에서는 무시합니다.
 */
class LogUtil {
  /**
   * 디버깅 모드일 때만 console.log를 출력합니다.
   */
  static log(...args: unknown[]): void {
    if (AppUtil.getDebugMode()) {
      console.log('[App]', ...args);
    }
  }

  /**
   * 디버깅 모드일 때만 console.warn을 출력합니다.
   */
  static warn(...args: unknown[]): void {
    if (AppUtil.getDebugMode()) {
      console.warn('[App Warning]', ...args);
    }
  }

  /**
   * 디버깅 모드일 때만 console.error를 출력합니다.
   */
  static error(...args: unknown[]): void {
    if (AppUtil.getDebugMode()) {
      console.error('[App Error]', ...args);
    }
  }

  /**
   * 디버깅 모드일 때만 console.info를 출력합니다.
   */
  static info(...args: unknown[]): void {
    if (AppUtil.getDebugMode()) {
      console.info('[App Info]', ...args);
    }
  }

  /**
   * 디버깅 모드일 때만 console.debug를 출력합니다.
   */
  static debug(...args: unknown[]): void {
    if (AppUtil.getDebugMode()) {
      console.debug('[App Debug]', ...args);
    }
  }
}

export default LogUtil;
